import { ForAgenciesSections } from '../components/for-agencies/ForAgenciesSections';
import { MarketingLandingShell } from '../components/marketing/MarketingLandingShell';
import { JsonLd } from '../components/seo/JsonLd';
import { PageSeo } from '../components/seo/PageSeo';
import { buildForAgenciesPageSchema } from '../lib/schema';
import { FOR_AGENCIES_META } from '../lib/seo';
import '../styles/solutions-landing.css';
import '../styles/for-agencies.css';

export function ForAgenciesPage() {
  return (
    <>
      <PageSeo meta={FOR_AGENCIES_META} />
      <JsonLd data={buildForAgenciesPageSchema()} />
      <MarketingLandingShell>
        <ForAgenciesSections />
      </MarketingLandingShell>
    </>
  );
}
